import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Recommend"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.9997 1.5C9.20759 1.50629 6.70751 3.23103 5.7102 5.839C4.71289 8.44696 5.42423 11.3998 7.49973 13.2675V22.5L11.9997 19.5L16.4997 22.5V13.2675C18.5752 11.3998 19.2866 8.44696 18.2893 5.839C17.292 3.23103 14.7919 1.50629 11.9997 1.5ZM14.9996 19.695L12.8321 18.255L11.9996 17.7L11.1671 18.255L8.99964 19.695V14.2875C10.8864 15.2394 13.1129 15.2394 14.9996 14.2875V19.695ZM15.6672 12C13.8788 13.746 11.1075 13.9891 9.04244 12.5813C6.97734 11.1734 6.19103 8.50492 7.16277 6.20223C8.13451 3.89953 10.5949 2.60112 13.0442 3.09837C15.4936 3.59563 17.2529 5.75067 17.2497 8.25001C17.2479 9.66195 16.6775 11.0137 15.6672 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Recommend.vue"]]);
